import React, { Component } from 'react';
import { Row, Col, Button, Table } from 'antd';
import CollapseCard from '../../../components/CollapseCard/CollapseCard';
import axios from '../../../axios/appAxios';
import moment from 'moment';
import config from 'react-global-configuration';
import { intl } from '../../../components/InilGlobalProvider/IntlGlobalProvider';

class MyTask extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataList: []
        }
    }
    
    //Calling fnSearch
    
    componentDidMount = () => {
        this.fnSearch();
    }
    
    //In case - click menu again for refresh data
    
    componentWillReceiveProps = (nextProps) => {
        this.setState({ dataList: [] }, () => { this.fnSearch(); });
    }
    
    //Fn search
    
    fnSearch = () => {
        return new Promise((resolve, reject) => {
            let listApi = [];
            listApi.push("/api/Worklist/WeightLicense/MyTask/GetAll");
            listApi.push("/api/Worklist/WasteSlip/MyTask/GetAll");
            listApi.push("/api/Worklist/ReceiveSolvent/MyTask/GetAll");
            listApi.push("/api/Worklist/SurveyByObserver/MyTask/GetAll");
            //Put API to promise array
            let promises = [];
            for (let i = 0; i < listApi.length; i++) {
                promises.push(axios.get(listApi[i]).then((response) => response.data));
            }

            Promise.all(promises).then((dataList) => {

                let tmpdataList = [];
                for (let dataItem of dataList) {
                    tmpdataList.push(...dataItem);
                }

                this.setState({ dataList: tmpdataList });

                //Exit promise
                resolve(dataList);
            });
        });
    }
    
    //Render
    
    render() {

        const columns = [
            {
                title: intl.msg({ id: 'tbl.Folio', defaultMessage: 'Folio' }),
                dataIndex: 'folio',
                sorter: (a, b) => {
                    return a.folio.toLowerCase().localeCompare(b.folio.toLowerCase());
                },
                render: (text, record) => {
                    if (record.processName == "Waste Slip") {
                        return (
                            <React.Fragment>
                                <a href={config.get("wasteAppBaseUrl") + "/request/waste-slip?pk=" + record.transactionId} target="_blank">{record.folio}</a>
                            </React.Fragment>
                        )
                    }
                    else if (record.processName == "Weight License") {
                        return (
                            <React.Fragment>
                                <a href={config.get("wasteAppBaseUrl") + "/request/weight-license?pk=" + record.transactionId} target="_blank">{record.folio}</a>
                            </React.Fragment>
                        )
                    }
                    else if (record.processName == "Receive Solvent") {
                        return (
                            <React.Fragment>
                                <a href={config.get("wasteAppBaseUrl") + "/request/solvent/receiveSolvent?pk=" + record.transactionId} target="_blank">{record.folio}</a>
                            </React.Fragment>
                        )
                    }
                    else if (record.processName == "Survey By Observer") {
                        return (
                            <React.Fragment>
                                <a href={config.get("wasteAppBaseUrl") + "/request/survey-by-observer?pk=" + record.transactionId} target="_blank">{record.folio}</a>
                            </React.Fragment>
                        )
                    }

                }
            },
            {
                title: intl.msg({ id: 'tbl.ProcessName', defaultMessage: 'Process Name' }),
                dataIndex: 'processName',
                width: 150,
                sorter: (a, b) => {
                    return a.processName.toLowerCase().localeCompare(b.processName.toLowerCase());
                }
            },
            {
                title: intl.msg({ id: 'tbl.ActivityName', defaultMessage: 'Activity Name' }),
                dataIndex: 'status',
                width: 150,
                sorter: (a, b) => {
                    return a.status.toLowerCase().localeCompare(b.status.toLowerCase());
                }
            },
            {
                title: intl.msg({ id: 'tbl.ActivityStartDate', defaultMessage: 'Activity Start Date' }),
                dataIndex: 'statusTimeStamp',
                width: 170,
                defaultSortOrder: 'descend',
                sorter: (a, b) => {
                    return a.statusTimeStamp.localeCompare(b.statusTimeStamp);
                },
                render: (text, record) => {
                    return (
                        <React.Fragment>
                            {moment.utc(record.statusTimeStamp).format("DD MMMM YYYY HH:mm")}
                        </React.Fragment>
                    )
                }
            },
            //{
            //    title: 'Destination',
            //    dataIndex: 'destination',
            //    width: 170,
            //    sorter: (a, b) => {
            //        return a.destination.toLowerCase().localeCompare(b.destination.toLowerCase());
            //    },
            //}
        ];

        return (
            <CollapseCard size="small" title="My Task">
                <Row>
                    <Col sm={24} md={24}>
                        <Table
                            columns={columns}
                            dataSource={this.state.dataList}
                            rowKey="transactionId"
                            bordered
                            size="small"
                            pagination={{ pageSize: 10, pageSizeOptions: ['10', '20', '50', '100'], showSizeChanger: true }}
                        />
                    </Col>
                </Row>
            </CollapseCard>
        );
    }
}

export default MyTask;
